import { render, staticRenderFns } from "./BlocoStatusCertificacoes.vue?vue&type=template&id=5dd156f6&scoped=true&lang=pug"
import script from "./BlocoStatusCertificacoes.vue?vue&type=script&lang=js"
export * from "./BlocoStatusCertificacoes.vue?vue&type=script&lang=js"
import style0 from "./BlocoStatusCertificacoes.vue?vue&type=style&index=0&id=5dd156f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd156f6",
  null
  
)

export default component.exports